import { travelTypeObject } from '../../enumeration';
import { PATH_DASHBOARD } from '../../routes/paths';
import api from '../../services/api';

const EAgent = {
  title: {
    name: ['عوامل کاروان', 'عوامل های کاروان'],
  },
  routes: PATH_DASHBOARD.caravanAgent,
  api: api.admin,
  // apiParams: { agent_id: [1,2,3,4] },
  agent_id: [1,2,3,4],
  apiParams: { is_agent : 1 },
  enum: {
    array: Object.values(travelTypeObject),
    object: travelTypeObject,
  },
};

export default EAgent;
